const CURRENT_CLASS = "is-current";
const VIEWPORT_CENTER_RATIO = 0.25;

let ticking = false;

function updateCurrentToc(list: Element): void {
  const items = list.querySelectorAll<HTMLLIElement>(".c-article-grid__aside-item");
  const links = list.querySelectorAll<HTMLAnchorElement>(".c-article-grid__aside-link[href^='#']");
  if (!items.length || !links.length || items.length !== links.length) return;

  const viewportMiddle = window.innerHeight * VIEWPORT_CENTER_RATIO;
  let currentId: string | null = null;

  for (let i = 0; i < links.length; i++) {
    const href = links[i].getAttribute("href");
    if (!href || href === "#") continue;
    const id = href.slice(1);
    const section = document.getElementById(id);
    if (!section) continue;

    const rect = section.getBoundingClientRect();
    if (rect.top <= viewportMiddle) {
      currentId = id;
    }
  }

  if (!currentId && links.length > 0) {
    const firstHref = links[0].getAttribute("href");
    if (firstHref && firstHref !== "#") currentId = firstHref.slice(1);
  }

  items.forEach((item, i) => {
    const link = item.querySelector<HTMLAnchorElement>(".c-article-grid__aside-link[href^='#']");
    const href = link?.getAttribute("href");
    const id = href && href !== "#" ? href.slice(1) : null;
    if (id === currentId) {
      item.classList.add(CURRENT_CLASS);
    } else {
      item.classList.remove(CURRENT_CLASS);
    }
  });
}

function onScroll(list: Element): void {
  if (!ticking) {
    requestAnimationFrame(() => {
      updateCurrentToc(list);
      ticking = false;
    });
    ticking = true;
  }
}

export const followToc = (): void => {
  const list = document.querySelector(".c-article-grid__aside-list");
  if (!list) return;

  updateCurrentToc(list);
  window.addEventListener("scroll", () => onScroll(list), { passive: true });
};
